import { useAppStore } from "./useAppStore";

export const useUser = () => {
  const impersonates = useAppStore.use.impersonation()?.impersonates;
  const user = useAppStore.use.user();

  return impersonates ?? user;
};
